module.exports = {
      id: "garage-usage",
      viewBox: "0 0 19 19.2",
      url: __webpack_public_path__ + "img/icons.a7e6c507.svg#garage-usage",
      toString: function () {
        return this.url;
      }
    }